import { getQuestionnaireQuestions, isIndicationFromBackend } from 'components/Questionnaire/functions';
import { updateQStack, infoAttributes } from 'components/Questionnaire/actions';
import { QUESTION_ID } from 'modules/questionnaire/questionIds';
import { GENERAL_DISEASE, GENERAL_DISEASE_SUB_TYPE } from 'utils/constants/disease';
import { DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';

const { [GENERAL_DISEASE]: GENERAL_DISEASE_SUB_TYPE_QUESTION_ID } = DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE;

// can handle
// - disease: general
// - disease: one of GENERAL_DISEASE_SUB_TYPE
export const conditionProfileFromIndication = async (disease) => {
  let conditionProfile = {};

  let adjustedDisease = disease;
  let generalDiseaseSubType;
  if (Object.values(GENERAL_DISEASE_SUB_TYPE).includes(disease)) {
    adjustedDisease = GENERAL_DISEASE;
    generalDiseaseSubType = disease;
  }

  const allQuestions = await getQuestionnaireQuestions(adjustedDisease);
  const qstack = updateQStack({
    allQuestions,
    form: {},
  });

  if (isIndicationFromBackend(adjustedDisease)) {
    conditionProfile = {
      [QUESTION_ID.tnm]: [],
      [QUESTION_ID.treatments.questionId]: [],
      [QUESTION_ID.procedures.questionId]: [],
      // ...mapFormToConditionProfile({}, allQuestions),
      qstack: qstack.map((q) => q.id),
    };

    delete conditionProfile.preferred_location;
  } else {
    conditionProfile = {
      [QUESTION_ID.treatments.questionId]: [],
      [QUESTION_ID.procedures.questionId]: [],
      // ...mapFormToConditionProfile(form, allQuestions),
      qstack: qstack.map((q) => q.id),
    };
  }

  if (adjustedDisease === GENERAL_DISEASE && generalDiseaseSubType) {
    conditionProfile[GENERAL_DISEASE_SUB_TYPE_QUESTION_ID] = generalDiseaseSubType;
    // qstack already has corresponding field
  }

  // Removes personal / info attributes from the condition_profile
  infoAttributes.forEach((a) => delete conditionProfile[a]);
  return conditionProfile;
};
